<template>
    <div class="wrap">
        <div class="content-wrap">
            <div class="close-icon" @click="$emit('close-overlay')">
                <span class="material-icons">
                    close
                </span>
            </div>
            <div class="user-info">
                <img :src="getImageUsrId(usr_id)" alt="user-avatar">
                <h3>{{usr_name}}</h3>
            </div>
            <div class="button-wrap">
                <div class="button-round green" @click="handleCall(true)">{{$t('call.answer')}}</div>
                <div class="button-round red" @click="handleCall(false)">{{$t('call.reject')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        usr_id: Number,
        usr_name: String
    },
    methods: {
        handleCall (value) {
            this.$emit('answer', value)
        }
    }
}
</script>

<style scoped lang="scss">
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background: rgba(0,0,0,.5);
    z-index: 100;
}
.content-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(min(100%, 400px));
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-radius: 25px;
    text-align: center;
}
.close-icon {
    position: absolute;
    top: 3%;
    right: 3%;
    color: black;
    cursor: pointer;
}
.button-round {
    color: var(--main-color);
    margin: 10px 0;
}
.red {
    background: var(--button-color-bright-red);
}
.green {
    background: var(--button-color-green);
}
</style>